import React, { ReactNode } from 'react';

import { SaveOutlined, SearchOutlined, TeamOutlined } from '@ant-design/icons';

import {
  DetailsHeaderActionGroup,
  DetailsHeaderActions,
  DetailsHeaderButton,
  DetailsHeaderEditActions,
} from '../../components/DetailsHeaderActions';
import { FlexibleDetailsHeaderLayout } from '../../components/FlexibleDetailsHeaderLayout';

type ProjectDetailsPageHeaderProps = {
  title?: ReactNode;
  onSave: () => void;
  onCancel: () => void;
  onShowSimilar: () => void;
  onShowRecommendations?: () => void;
};

export const ProjectDetailsPageHeader: React.FC<ProjectDetailsPageHeaderProps> = ({
  title,
  onCancel,
  onSave,
  onShowSimilar,
  onShowRecommendations,
}) => {
  return (
    <FlexibleDetailsHeaderLayout
      title={title}
      rootTestId="project-details-header"
      titleTestId="project-details-header-title"
      actionsTestId="project-details-header-actions"
      actions={
        <DetailsHeaderActions>
          <DetailsHeaderActionGroup>
            {onShowRecommendations && (
              <DetailsHeaderButton icon={<TeamOutlined aria-hidden />} onClick={onShowRecommendations}>
                Candidate matches
              </DetailsHeaderButton>
            )}
            <DetailsHeaderButton icon={<SearchOutlined aria-hidden />} onClick={onShowSimilar}>
              Find Similar Projects
            </DetailsHeaderButton>
          </DetailsHeaderActionGroup>
          <DetailsHeaderEditActions>
            <DetailsHeaderButton onClick={onCancel}>Cancel</DetailsHeaderButton>
            <DetailsHeaderButton type="primary" icon={<SaveOutlined aria-hidden />} onClick={onSave}>
              Save
            </DetailsHeaderButton>
          </DetailsHeaderEditActions>
        </DetailsHeaderActions>
      }
    />
  );
};
